import React, { Component } from 'react';

import Api from '../../api/advert';
import intl from 'react-intl-universal';
import Select from 'react-select';




export default class Advert extends Component {
  constructor(props) {
    super();
    this.state = {
      records: []
    };

  }

  componentDidMount() {

    this.getData();

  }

  render() {
    let {
      records
    } = this.state
    return (
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <img style={{ width: '100%', height: 125 }} src={require('../../assets/image/advert.png')} alt="" />
        {records.map((item, index) => {
         if(index<=2){
          return (
            <div style={{ display: 'flex', padding: 15, flexDirection: 'row', borderBottom: '1px solid #cccccc' ,marginTop:10,alignItems:'center'}} key={index}>
              <img style={{ width: 80, height: 80 }} src={item.image_url} alt="" />

              <div style={{ display: 'flex', flexDirection: 'column', marginLeft: 10 ,fontSize:12,color:'black',}}>
                <div style={{lineHeight:1}}>{item.title}</div>
                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '90%' ,marginTop:8}}>
                  <div>
                    <div style={{color:'#eb6c6c',lineHeight:1,marginBottom:4}}>
                      Leadshub<div>平台价</div>
                    </div>
                    <div style={{color:'#eb6c6c',}}>{'￥' + item.price}</div>
                  </div>

                  <div>
                    <div style={{lineHeight:1,marginBottom:4}}>
                      建议<div>零售价</div>
                    </div>
                    <div>{'￥' + item.retail_price}</div>
                  </div>

                  <div>
                    <div style={{lineHeight:1,marginBottom:4}}>
                      利润率<div>利润</div>
                    </div>
                    <div>{item.profit_rate+'/￥'+item.profit}</div>
                  </div>

                </div>
              </div>

            </div>
          )
         }
        })}

        <div style={{color:'#eb6c6c',paddingLeft:15,marginTop:15}}>*<span style={{color:"black"}}>如需购买,请在“Leadshub”App中进行下单购买</span></div>
      </div>
    )
  }

  getData() {
  
     
    let spec=this.getQueryString('spec')
    let brands=this.getQueryString('brands')
    let param = {
      platform: 'TuHu',
      brands: brands?brands:'普利司通',
      spec: spec?spec:'215/65R16'
    }
    Api.getAdvert(param).then(res => {
      if (res.data.code == 0) {
        this.setState({ records: res.data.data.data.tires })
      }
    })
  }

  getQueryString(name) {
    let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    let r = window.location.search.substr(1).match(reg);
    if (r != null) return decodeURI(r[2]); return null;
  }

}



// WEBPACK FOOTER //
// ./src/views/advert/Advert.js